<script setup>
import { ref, inject, watch } from 'vue'
import { Virtual } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/virtual'

import Thumbnail from '@/components/carousel/thumbnail.vue'
import IconButton from '@/components/buttons/IconButton.vue'
import IconChevron from '@/components/icons/IconChevron.vue'

const { thumbnails } = inject('thumbnails')
const { canvasIndex } = inject('canvasIndex')

const swiperRef = ref(null)

watch(canvasIndex, (newIndex) => {
  if (swiperRef.value) {
    swiperRef.value.slideTo(Math.floor(newIndex / 2))
  }
})

const onReady = (swiper) => {
  swiperRef.value = swiper
}

const goBackLots = () => {
  if (swiperRef.value) {
    swiperRef.value.slideTo(Math.max(0, swiperRef.value.activeIndex - 5))
  }
}

const goBack= () => {
  if (swiperRef.value) {
    swiperRef.value.slidePrev()
  }
}

const goNextLots = () => {
  if (swiperRef.value) {
    swiperRef.value.slideTo(Math.min(thumbnails.value.length - 1, swiperRef.value.activeIndex + 5))
  }
}

const goNext= () => {
  if (swiperRef.value) {
    swiperRef.value.slideNext()
  }
}
</script>

<template>
  <div class="carousel-container px-4 pt-1 grid grid-flow-co items-center gap-[60px] max-h-full fill-cream">
    <div class="grid grid-flow-col gap-4 h-10">
      <IconButton @click="goBackLots">
        <div class="flex">
          <IconChevron class="h-25 rotate-180" />
          <IconChevron class="h-25 rotate-180" />
        </div>
      </IconButton>
      <IconButton @click="goBack">
        <IconChevron class="h-25 rotate-180" />
      </IconButton>
    </div>
    <div class="w-full">
      <Swiper
        :modules="[Virtual]"
        :slides-per-view="5"
        :virtual="true"
        @swiper="onReady"
        class="w-full"
      >
        <SwiperSlide
          v-for="(t, i) in thumbnails"
          :key="`tb-${i}`"
          :virtualIndex="i"
        >
          <Thumbnail :spread="t"/>
        </SwiperSlide>
      </Swiper>
        
    </div>
    <div class="grid grid-flow-col gap-4 h-10">
      <IconButton @click="goNext">
        <IconChevron class="h-25" />
      </IconButton>
      <IconButton @click="goNextLots">
        <div class="flex">
          <IconChevron class="h-25" />
          <IconChevron class="h-25" />
        </div>
      </IconButton>
    </div>
  </div>
</template>

<style>
.carousel-container {
  max-width: 100vw;
  grid-template-columns: min-content 1462px min-content;
}
</style>
